import { withRX } from '@devexperts/react-kit/dist/utils/with-rx2';
import { asks } from 'fp-ts/lib/Reader';
import { Toasts } from './Toasts';
export var ToastsContainer = asks(function (ctx) {
    return withRX(Toasts)(function () {
        return {
            defaultProps: {
                toasts: [],
            },
            props: {
                toasts: ctx.toastService.toasts$,
            },
        };
    });
});
//# sourceMappingURL=ToastsContainer.js.map